
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'

const agentStaffRes = sessionStorage.getItem('agentStaffRes') ? JSON.parse(sessionStorage.getItem('agentStaffRes')) : {}

export default {
name: 'industryChecker',
data () {
return {
selectedIndustry: [],
industryList: []
}
},
props: {
value: {
type: Boolean,
default: false
},
max: {
type: Number
},
title: {
type: String,
default: '请选择行业'
},
data: {
type: Array,
default: () => []
},
disable: {
type: Array,
default: () => []
}
},
directives: {
TransferDom
},
components: {
Popup,
PopupHeader,
Group,
Checker,
CheckerItem
},
watch: {
value (val) {
if (val && this.disable && this.disable[0]) {
this.selectedIndustry.forEach((item,index) => {
if (item.split('|')[0] == this.disable[0].id) {
this.selectedIndustry.splice(index, 1)
}
})
}
}
},
created () {
},
mounted () {
this.agentStaffId = agentStaffRes.agentStaffId
},
methods: {
onHide () {
this.$emit('close')
},
onConfirm () {
let data = []
this.selectedIndustry.forEach(item => {
data.push({
name: item.split('|')[1],
id: item.split('|')[0]
})
})
this.$emit('ok', data)
},
checkChange (val) {
console.log(val)
console.log('不可选', this.disable)
},
disableItem (item) {
let bl = false
if (this.disable && this.disable[0] && this.disable[0].id == item.industryId) {
bl = true
}
if (this.selectedIndustry.length == this.max) {
bl = true
this.selectedIndustry.forEach(selected => {
if (selected.split('|')[0] == item.industryId) {
bl = false
}
})
}


return bl
}
}
}



// WEBPACK FOOTER //
// ./src/plugin/industry-checker.vue